import React from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';

import { Tabs, TabsSize } from 'app/design-system/components/Tabs';

import styles from './TimeFilterUI.module.scss';

type TimeFilterUITab = {
  id: string;
  to: string;
  label: JSX.Element | string;
  dataGaValue?: Record<string, string | number>;
};

type TimeFilterUIProps = {
  className?: string;
  tabs?: {
    items: TimeFilterUITab[];
    defaultActiveId?: string;
  };
};

export const TimeFilterUI = ({ tabs, className }: TimeFilterUIProps) => {
  const { search } = useLocation();
  const urlParams = new URLSearchParams(search);

  if (!tabs?.items) {
    return null;
  }

  const TimeFilterUIClassNames = classNames(styles.tabs, className);

  const activeTabId = urlParams.get('timeFilter') || tabs.defaultActiveId;

  return (
    <Tabs type="link"
          size={TabsSize.SMALL}
          tabs={tabs.items}
          activeTabId={activeTabId ?? undefined}
          disableActiveTab={false}
          className={TimeFilterUIClassNames} />
  );
};
